import { formatCallerNumber, formatLine } from '../../modules/telephony/utils/callFormat';

/** «097 322 00 44 · Іваненко Петро (ТОВ «Ромашка»)» — хто дзвонить, коротко */
function describeCaller(call) {
  const parts = [formatCallerNumber(call.callerNumberRaw)];
  const person = call.match?.contactPersons?.[0];
  const counterparty = call.match?.counterparties?.[0];
  if (person) {
    const orgs = (person.counterparties || []).map((c) => c.name).join(', ');
    parts.push(orgs ? `${person.name} (${orgs})` : person.name);
  } else if (counterparty) {
    parts.push(counterparty.name);
  } else if (call.callerName) {
    parts.push(call.callerName);
  }
  return parts.join(' · ');
}

/**
 * SSE-подія телефонії → системне (Windows) сповіщення для desktop-додатка,
 * або null, якщо подія сповіщення не потребує. `key` — для дедупу: ringing
 * приходить повторно (по кожному extension і в initial-снапшоті після
 * реконекту SSE), а тост має бути один.
 */
export function toastForCallEvent(event, data) {
  switch (event) {
    case 'call.ringing':
      return {
        key: `ringing:${data.callId}`,
        title: 'Вхідний дзвінок',
        body: describeCaller(data),
        line2: formatLine(data.line, data.did),
        target: `/telephony/calls/${data.callId}`,
      };
    case 'call.ended':
      if (data.status !== 'MISSED') return null;
      return {
        key: `missed:${data.callId}`,
        title: 'Пропущений дзвінок',
        body: describeCaller(data),
        line2: formatLine(data.line, data.did),
        target: `/telephony/calls/${data.callId}`,
        tone: 'danger',
      };
    case 'inquiry.escalated':
      return {
        key: `escalated:${data.eventId}`,
        title: 'Питання куратору',
        body: data.subject || '',
        line2: '',
        target: `/telephony/inquiries/${data.inquiryId}`,
      };
    default:
      return null;
  }
}
